module.exports = __webpack_public_path__ + "static/img/activity_sdy_01-1.ea539c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_01-1.jpg
// module id = nxz7
// module chunks = 0